/**
 * Module-level holder for the active tenant slug. The API client reads this
 * synchronously to set the X-Tenant header, so it lives outside React state.
 * The TenantProvider keeps it in sync with React + localStorage.
 */
const STORAGE_KEY = 'mg.activeTenant';

let activeTenantSlug: string | null = readStored();

function readStored(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function getActiveTenantSlug(): string | null {
  return activeTenantSlug;
}

export function setActiveTenantSlug(slug: string | null): void {
  activeTenantSlug = slug;
  try {
    if (slug) window.localStorage.setItem(STORAGE_KEY, slug);
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore storage failures (private mode, etc.)
  }
}
